export default "__VITE_ASSET__Djek7D5$__"